import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createProductCategoryApi,
  deleteProductCategoryApi,
  getProductCategoriesApi,
  productCategoryFileUploadApi,
  updateProductCategoryApi,
} from "../../api/ecommerce/ProductCategoryApi";

const initialState = {
  categories: {},
  createResponse: {},
  updateResponse: {},
  deleteResponse: {},
  loading: false,
  saving: false,
  deleting: false,
    combineFileUploading: false,
  fileuploadResponse: [],
};

export const getProductCategories = createAsyncThunk(
  "productCategory/getProductCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getProductCategoriesApi();
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const createProductCategory = createAsyncThunk(
  "productCategory/createProductCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createProductCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateProductCategory = createAsyncThunk(
  "productCategory/updateProductCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateProductCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteProductCategory = createAsyncThunk(
  "productCategory/deleteProductCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteProductCategoryApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);


export const productCategoryFileUpload = createAsyncThunk(
  "productCategory/multipleImageUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await productCategoryFileUploadApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

const productCategorySlice = createSlice({
  name: "productCategory",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getProductCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProductCategories.fulfilled, (state, action) => {
      state.categories = action?.payload;
      state.loading = false;
    });
    builder.addCase(getProductCategories.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(createProductCategory.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(createProductCategory.fulfilled, (state, action) => {
      state.createResponse = action?.payload;
      state.saving = false;
    });
    builder.addCase(createProductCategory.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(updateProductCategory.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateProductCategory.fulfilled, (state, action) => {
      state.updateResponse = action?.payload;
      state.saving = false;
    });
    builder.addCase(updateProductCategory.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(deleteProductCategory.pending, (state) => {
      state.deleting = true;
    });
    builder.addCase(deleteProductCategory.fulfilled, (state, action) => {
      state.deleteResponse = action?.payload;
      state.deleting = false;
    });
    builder.addCase(deleteProductCategory.rejected, (state) => {
      state.deleting = false;
    });

      //website files
        builder.addCase(productCategoryFileUpload.pending, (state) => {
          state.combineFileUploading = true;
        });
        builder.addCase(productCategoryFileUpload.fulfilled, (state, action) => {
          state.fileuploadResponse = action.payload.response;
          state.combineFileUploading = false;
        });
        builder.addCase(productCategoryFileUpload.rejected, (state) => {
          state.combineFileUploading = false;
        });
  },
});

export default productCategorySlice.reducer;
